import type { ComponentProps } from 'react';
import { Link } from 'react-router';
import { cn } from '../../utils/cn';
import { Icon } from '../Icon';

type PaginationPreviousProps = ComponentProps<typeof Link>;

export const PaginationPrevious = ( { className, ...linkAttributes }: PaginationPreviousProps ) => {

  return (
    <Link
      className={ cn( 'size-full flex items-center justify-center', className ) }
      { ...linkAttributes }>
      <Icon
        className={ 'text-[20px]' }
        name={ 'chevron-left' }
      />
    </Link>
  )
}
PaginationPrevious.displayName = 'PaginationPrevious';
